import { emailLifeBody } from "../EmailTemplates/EmailBodies";
import LifeEmailContent from "./Life/LifeEmailContent";

export const emailResult = async (lang, pageData, resultData, checkedBtns) => {
  const emailBody = await emailLifeBody(lang, pageData, resultData, checkedBtns);
  window.location.href = `mailto: ?subject=${encodeURIComponent(
    LifeEmailContent.subject[lang]
  )}&body=${encodeURIComponent(emailBody)}`;
};
